import { render, staticRenderFns } from "./feedback_chat.vue?vue&type=template&id=66fe35ca&"
import script from "./feedback_chat.vue?vue&type=script&lang=js&"
export * from "./feedback_chat.vue?vue&type=script&lang=js&"
import style0 from "./feedback_chat.vue?vue&type=style&index=0&id=66fe35ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports